// // This is a placeholder for latent shadowing in sibling themes
// /** @jsx jsx */
// import { jsx } from "theme-ui"

// const Footer = () => {
//   return (
//     <footer
//       id="footer"
//     >
//       <p>Foaaaoter area for latent shadowing in sibling themes src/gatsby-theme-catalyst-core/src/components/footer.js</p>
//     </footer>
//   )
// }

// export default Footer

/** @jsx jsx */
import { jsx} from "theme-ui"
import { useSiteMetadata } from "gatsby-theme-catalyst-core"
import Bak from "/content/assets/front_bright.png"
import Mess from "/content/assets/mess.png"
const BackgroundImg = `url(${Bak}) , url(${Mess})`

const SiteFooter = () => {
  const { title } = useSiteMetadata()
 
  return (
    <footer >
      <div
        style={{
          minHeight:"60vh",
          background: BackgroundImg,
          backgroundSize: "cover, contain",
          borderTop: "2px dashed blue",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          
        }}
        >
      <div 
        style={{
          maxWidth: "720px",
          padding: "1rem",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        >
          <h3
          style={{
            background: "yellow"
          }}
          >Abolition Plaza</h3>
          <p>
           {new Date().getFullYear()} {title} 

          </p>
        </div>
      </div>
    </footer>
  )
}

export default SiteFooter